import React from 'react';
import { LandingPage } from './LandingPage';
import { TripuraSignInPage } from './TripuraSignInPage';
import { DpsSignInPage } from './DpsSignInPage';
import { getTenantFromHostname } from '../utils';

export const TenantEntryPage: React.FC = () => {
  const tenant = getTenantFromHostname();

  if (tenant === 'tripura') return <TripuraSignInPage />;
  if (tenant === 'dps') return <DpsSignInPage />;

  return <LandingPage />;
};
